<div>（モーダルのフッタ部分のHTML）</div>
